<script lang="ts" setup>
import { ref } from 'vue';
import { CdrAccordion } from '@rei/cedar';
import type { ResourceSubSectionProps } from '@returns-page/types/index.mts';

const props = defineProps<ResourceSubSectionProps>();

const opened = ref(false);

const toggleAccordion = () => {
  opened.value = !opened.value;
};
</script>

<template>
  <cdr-accordion
    :id="props.sectionId"
    :opened="opened"
    level="3"
    @accordion-toggle="toggleAccordion"
  >
    <template #label>
      {{ props.title }}
    </template>
    <div
      class="resource-sub-section__content"
      v-html="props.body"
    />
  </cdr-accordion>
</template>

<style lang="scss">
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';
@import '@rei/cdr-component-variables/dist/scss/index.scss';

.resource-sub-section {
  &__content {
    & > ul {
      @include cdr-list-base-mixin;
      @include cdr-list-unordered-mixin;

      margin-bottom: $cdr-space-one-x;
      padding-left: none;
    }

    & > ol {
      @include cdr-list-base-mixin;
      @include cdr-list-ordered-mixin;

      margin-bottom: $cdr-space-one-x;
      padding-left: $cdr-space-two-x;
    }
  }
}
</style>
